// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import React from 'react';
import {
  FormLabel,
  TextField,
  makeStyles,
  FormHelperText,
  Button,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import styles from './styles';

export default function FormDefaultTextField(props) {
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const {
    id,
    name,
    value,
    helperText,
    defaultText,
    defaultText1,
    defaultTextClass,
    defaultTextClass1,
    copyText,
    onCopyClick,
    textInputClass,
    isDisabled = false,
    multiline = false,
    rows = 1,
    handleChange,
    handleBlur,
    error = false,
    textFieldContainerClass = '',
  } = props;
  const defaultClass = error ? clsx(classes.defaultTextField, defaultTextClass, classes.error)
    : clsx(classes.defaultTextField, defaultTextClass);
  const defaultClass1 = error ? clsx(classes.defaultTextField, defaultTextClass1, classes.error)
    : clsx(classes.defaultTextField, defaultTextClass1);
  const textFiledClass = clsx(classes.textField, textInputClass);

  return (
    <div className={classes.fieldContainer} id={id} data-apim-test={id}>
      <div>
        <FormLabel className={classes.formLabel}>
          {name}
        </FormLabel>
      </div>
      <div className={textFieldContainerClass}>
        {defaultText &&
          <div className={defaultClass}>
            {defaultText}
          </div>
        }
        <TextField
          id={`${id}-textfield`}
          classes={{
            root: textFiledClass,
          }}
          variant="outlined"
          multiline={multiline}
          error={error}
          rows={rows}
          onChange={(e) => handleChange(e.target.value)}
          onBlur={(e) => handleBlur && handleBlur(e.target.value)}
          value={value}
          disabled={isDisabled}
        />
        {defaultText1 &&
          <div className={defaultClass1}>
            {defaultText1}
          </div>
        }
        {copyText &&
          <Button
            id="copy-key-btn"
            variant="outlined"
            onClick={onCopyClick}
            className={classes.copyButton}
            >
            {copyText}
          </Button>
        }
      </div>
      <div>
        <FormHelperText className={classes.helperText} error={error}>
          {helperText}
        </FormHelperText>
      </div>
    </div>
  );
}

FormDefaultTextField.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.string,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  error: PropTypes.bool,
  id: PropTypes.string,
  value: PropTypes.string,
  rows: PropTypes.number,
  defaultText: PropTypes.string,
  multiline: PropTypes.bool,
  isDisabled: PropTypes.bool,
  defaultText1: PropTypes.string,
  textInputClass: PropTypes.object,
  onCopyClick: PropTypes.func,
  copyText: PropTypes.string,
  defaultTextClass: PropTypes.object,
  defaultTextClass1: PropTypes.object,
  textFieldContainerClass: PropTypes.object,
};
